// tslint:disable
import * as React from 'react'
import Request, { PROD_URL } from '@/utils/request'
import { getJsonFromUrl, isTest } from '@/utils/tools'
import globalBus from '@/services/Bus'
import './HomeActiveCouponStyle'
import { reportViewEvent, reportClickEvent } from '@weike/operation-report'
import { RegisterElement } from '@/services/hotspotReport'

declare const window: any

interface HomeActiveCouponState {
  beginShowTime: boolean
  isDialogShow: boolean
  dialogUrl: string
  dialogImg: string
  dialogId: string
  dialogIndex: number
  isA: boolean
}
interface Iprops {
  id: string
  img_url: string
  index: number
  link: string
  open_test: boolean
}
type accountType = {
  avatar_url: string
  id: number
  nickname: string
  sex: number
  small_avatar_url: string
  subscribed: boolean
  telephone_validate: boolean
  token: string
}

export default class HomeActiveCoupon extends React.Component<Iprops, HomeActiveCouponState> {
  private headerRefs: React.RefObject<HTMLDivElement>
  private timer: any
  constructor(props: any) {
    super(props)
    this.state = {
      beginShowTime: false,
      isDialogShow: false,
      dialogUrl: '',
      dialogImg: '',
      dialogId: '',
      dialogIndex: 0,
      isA: true
    }
    this.headerRefs = React.createRef()
  }

  public componentDidMount() {
    // this.fetchCoupon()
    this.setState({
      dialogId: this.props.id,
      dialogImg: this.props.img_url,
      dialogUrl: this.props.link,
      dialogIndex: this.props.index
    })
    this.recordPopWindowCoupon('view')
    setTimeout(() => {
      this.popDialog(this.props)
    }, 0)
  }

  public fetchCoupon() {
    Request.$get(`${isTest() ? location.origin : PROD_URL}/popwindow/api/config/request/index/popwindow/`, {}).then(res => {
      const data = res.data.data
      if (res.data.code === 0) {
        this.setState({
          dialogId: data.config.id,
          dialogImg: data.config.img_url,
          dialogUrl: data.config.link,
          dialogIndex: data.config.index
        })
        this.recordPopWindowCoupon('view')
        this.popDialog(data.config)
      }
    })
  }

  public toggleDialog(action: any, cb?: () => void) {
    const param = new FormData()
    param.append('config_id', this.state.dialogId)
    Request.$post(`${isTest() ? location.origin : PROD_URL}/popwindow/api/record/${action}/index/popwindow/`, param)
    setTimeout(() => {
      cb && cb()
    }, 50)
  }

  // 挽留弹窗
  public openDialog = () => {
    globalBus.emit({
      dialogInfo: {
        isShow: true,
        title: '真的要放弃专属大额红包吗',
        subTitle: '仅此一次机会，关闭后不可再次领取',
        fn: [
          {
            tag: 'cancel',
            name: '残忍拒绝',
            fn: () => {
              globalBus.emit({ dialogInfo: { isShow: false } })
            }
          },
          {
            tag: 'success',
            name: '我要领取',
            fn: () => {
              globalBus.emit({ dialogInfo: { isShow: false } })
              this.onClickDialog(null, 'dialog')
            }
          }
        ]
      }
    })
  }

  public popDialog(config: any) {
    let isA
    if (config.open_test) {
      isA = config.test_case === 'a'
    } else {
      isA = true
    }
    this.setState({ isA, isDialogShow: true })
    this.mta(`main-dialog-show-${config.id}-${isA ? 'a' : 'b'}`)
    if (this.headerRefs.current && this.headerRefs.current !== null) {
      this.headerRefs &&
        this.headerRefs.current.addEventListener('webkitAnimationEnd', () => {
          this.setState({ beginShowTime: true })
        })
    }
  }

  public mta(payload: string) {
    window.MtaH5 && window.MtaH5.clickStat(payload)
    window._czc && window._czc.push(['_trackEvent', 'common', 'click', payload, 1])
  }

  public onClickDialog(e: any = null, model: string = 'default') {
    if (e) {
      e.stopPropagation()
    }
    const isA = this.state.isA
    this.recordPopWindowCoupon('click')
    this.setState({ isDialogShow: false })
    this.mta(`main-dialog-${this.state.dialogId}-click-${isA ? 'a' : 'b'}`)
    this.toggleDialog('click', () => {
      Request.$get('/api/account/self', {}).then(res => {
        if (res.data.code === 0) {
          location.assign(this.getHasInviterIdUrl(res.data.data, model))
        }
      })
    })
  }

  public recordPopWindowCoupon(type: 'click' | 'view') {
    const { id, index, link } = this.props
    try {
      if (type === 'click') {
        reportClickEvent(`popover__${id}`, { url: link, index: index })
      } else {
        reportViewEvent(`popover__${id}`, { url: link, index: index })
      }
    } catch (e) {}
  }

  public componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }

  public onCloseDialog = (e: any = null) => {
    e.stopPropagation()
    this.toggleDialog('cancel')
    this.openDialog()
    this.setState({ isDialogShow: false })
    this.mta(`main-dialog-${this.state.dialogId}-close-${this.state.isA ? 'a' : 'b'}`)
  }

  // 老的InviterId逻辑
  public getHasInviterIdUrl(account: accountType, model: string = null) {
    const dialogInviterIdId = '61329026'
    const { dialogIndex, dialogUrl, isA } = this.state
    const querySymbol = dialogUrl.includes('?') ? '&' : '?'
    let backFollowedInviterId, backNoFollowedInviterId, othersInviterId
    if (dialogIndex === 0) {
      backFollowedInviterId = isA ? '44006949' : '53845374'
      backNoFollowedInviterId = isA ? '44814268' : '53845447'
      if (model === 'dialog') {
        othersInviterId = dialogInviterIdId
      } else {
        othersInviterId = isA ? '44814368' : '54460640'
      }
    } else if (dialogIndex === 1) {
      backFollowedInviterId = isA ? '52439452' : '53845210'
      backNoFollowedInviterId = isA ? '52439551' : '53845263'
      if (model === 'dialog') {
        othersInviterId = dialogInviterIdId
      } else {
        othersInviterId = isA ? '52440369' : '53845298'
      }
    } else {
      backFollowedInviterId = isA ? '54460715' : '55790658'
      backNoFollowedInviterId = isA ? '54460755' : '55790717'
      if (model === 'dialog') {
        othersInviterId = dialogInviterIdId
      } else {
        othersInviterId = isA ? '54460799' : '55790861'
      }
    }
    const from = getJsonFromUrl().from
    if (from === 'outside_site') {
      if (account.subscribed) {
        return `${dialogUrl}${querySymbol}inviter_id=${backFollowedInviterId}`
      } else {
        return `${dialogUrl}${querySymbol}inviter_id=${backNoFollowedInviterId}`
      }
    } else {
      return `${dialogUrl}${querySymbol}inviter_id=${othersInviterId}`
    }
  }

  public render() {
    if (this.state.isDialogShow) {
      return (
        <div className="mainactive__coupon" onClick={e => this.onCloseDialog(e)}>
          <div className="coupon__img" style={{ marginTop: '-50px' }} ref={this.headerRefs} onClick={e => this.onClickDialog(e)}>
            <img src={this.state.dialogImg} alt="" />
            <div className="coupon__close" style={{ opacity: this.state.beginShowTime ? 1 : 0 }}>
              <img src="https://static-1253442168.image.myqcloud.com/picture/7931794_0b01d709a9a40d4365bf516840205510.jpg" alt="" onClick={e => this.onCloseDialog(e)} />
            </div>
          </div>
        </div>
      )
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeActiveCoupon/HomeActiveCoupon.tsx